import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import Default from '../../views/Default';
import ImageCategorisation from '../../views/ImageCategorisation';
import ImgCateThankYou from '../../views/ImageCategorisation/ImgCateThankYou';
import ProjectApollo from '../../views/ProjectApollo';
import BboxImgRes from '../../views/BboxImgRes';
import ImageSegmentQuestion from '../../views/ImageSegmentQuestion';
import ImageSegmentAckTaskEnd from '../../views/ImageSegmentQuestion/ImageSegmentAckTaskEnd';
import ImageSegmentAckTaskContinue from '../../views/ImageSegmentQuestion/ImageSegmentAckTaskContinue';
import ProjectDemeter from '../../views/ProjectDemeter';
import ProjectGorgon from '../../views/ProjectGorgon';
import ProjectKratosEC from '../../views/ProjectKratosEC'
import ProjectHermes from '../../views/ProjectHermes'
import ProjectEros from '../../views/ProjectEros'
import ProjectLeto from '../../views/ProjectLeto'
import ProjectPhobos from '../../views/ProjectPhobos'
import ProjectDeimos from '../../views/ProjectDeimos'

export default function Home(){
    return (
        <Router>
            <div>
                <Switch>
                    <Route path="/imageCate" component={ImageCategorisation} />
                    <Route exact  path="/imgCateThankYou" component={ImgCateThankYou} />
                    <Route path="/projectApollo" component={ProjectApollo} />
                    <Route exact  path="/bboxImgRes/:taskId" component={BboxImgRes} />
                    <Route path="/imageSegmentQuestion" component={ImageSegmentQuestion} />
                    <Route path="/imageSegmentAckTaskEnd" component={ImageSegmentAckTaskEnd} />
                    <Route path="/imageSegmentAckTaskContinue" component={ImageSegmentAckTaskContinue} />
                    <Route path="/projectDemeter" component={ProjectDemeter} />
                    <Route path="/projectGorgon" component={ProjectGorgon} />
                    <Route path="/projectKratosec" component={ProjectKratosEC} />
                    <Route path="/projectHermes" component={ProjectHermes} />
                    <Route path="/projectEros" component={ProjectEros} />
                    <Route path="/projectLeto" component={ProjectLeto} />
                    <Route path="/projectPhobos" component={ProjectPhobos} />
                    <Route path="/projectDeimos" component={ProjectDeimos} />
                    <Route component={Default} />
                </Switch>    
            </div> 
        </Router>  
    )
}


// WEBPACK FOOTER //
// ./src/containers/Home/Home.js